import { render, staticRenderFns } from "./create-configuration.vue?vue&type=template&id=bf1467a2&scoped=true"
import script from "./create-configuration.vue?vue&type=script&lang=js"
export * from "./create-configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1467a2",
  null
  
)

export default component.exports